import * as types from '../actiontypes';

export const setItProcessSelected = (id) => {
	return {
		type: 'itProcesses/selected',
		id
	};
};

export const setItApplicationSelected = (id) => {
	return {
		type: 'itApplication/selected',
		id
	};
};

export const clientSideSearch = (bodyId, entityName, filters) => {
	return {
		type: types.BODIES_SPECIAL_CLIENTSIDE_FILTERS,
		bodyId,
		entityName,
		filters
	};
};
